const cSRenderCalculatorResults = ($container) => {
	let html =
		"<div>" +
		'<div><span>Post deliverables: </span><span id="cscalc-postdeliverables">0$</span></div>' +
		'<div><span>Usage rights: </span><span id="cscalc-usagerights">0$</span></div>' +
		'<div><span>Exclusivity: </span><span id="cscalc-exclusivity">0$</span></div>' +
		'<div><span>Industry: </span><span id="cscalc-industry">0$</span></div>' +
		'<div><span>Busy time: </span><span id="cscalc-busytime">0$</span></div>' +
		'<div><span>Quick turn: </span><span id="cscalc-quickturn">0$</span></div>' +
		'<div><span>Giveaway: </span><span id="cscalc-giveaway">0$</span></div>' +
		'<div><span>Out of pocket: </span><span id="cscalc-pocket">0$</span></div>' +
		'<div><b><span>Total rate: </span><span class="cscalc-total">0$</span></b></div>' +
		'<div><span>Opt-in platform rate: </span><span id="cscalc-optintotal">0$</span></div>' +
		"</div>";

	$container.innerHTML = html;
};
export default cSRenderCalculatorResults;
